import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'DateFormatPipe',
})
export class DateFormatPipe implements PipeTransform {
    transform(value: any, format: any) {
        var datePipe = new DatePipe("en-US");
        value = datePipe.transform(value, format);
        return value;
    }
}